import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import { BadgeComponent } from './badge.component';

export const ngxBadgeModule = angular.module('ngxBadgeModule', [])
	.directive('ngxBadge', downgradeComponent({ component: BadgeComponent }))
	.name;
